import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {
  Source,
  trackSystemPageErrored
} from 'middleware/analytics/actions/trackSystemPageErrored'
import {getHotelResult} from 'modules/searchApi/selectors'

import {useRouterProvider} from '@vio/core/src/_web/router/context/RouterContext'
import {
  getSearchApiErrorMessage,
  SearchApiError
} from '@vio/core/src/sapi/services/searchApi'

/**
 * Handle hotel fetch error by redirecting home
 */
export const useRedirectHome = ({hotelId}: {hotelId: string}) => {
  const dispatch = useDispatch()
  const {error} = useSelector(state => getHotelResult(state, hotelId))
  const errorStatusCode = error && 'status' in error ? error.status : undefined
  const {push} = useRouterProvider()

  useEffect(() => {
    if (error) {
      const errorMessage = `Error fetching hotel "${hotelId}": ${getSearchApiErrorMessage(error)}`
      dispatch(
        trackSystemPageErrored({
          payload: {
            source: Source.Routes,
            message: errorMessage
          }
        })
      )

      if (errorStatusCode === 404) {
        push('/')
      } else {
        throw new SearchApiError('Error fetching hotel', error)
      }
    }
  }, [hotelId, error, errorStatusCode, dispatch, push])
}
